export { CommandEventType, CommandName } from "@eyeo-fragments/in-product-messaging/background";
export var FragmentType;
(function (FragmentType) {
    FragmentType["future"] = "future";
})(FragmentType || (FragmentType = {}));
